import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Loader2Icon } from 'lucide-react';
import { AdminDataProvider, useAdminData } from './contexts/AdminDataContext';
import { AdminShell } from './components/admin/AdminShell';
import { PublicSite } from './pages/PublicSite';
import { AdminLogin } from './pages/admin/AdminLogin';
import { Overview } from './pages/admin/Overview';
import { Enquiries } from './pages/admin/Enquiries';
import { Cases } from './pages/admin/Cases';
import { CaseNew } from './pages/admin/CaseNew';
import { CaseDetail } from './pages/admin/CaseDetail';
import { Customers } from './pages/admin/Customers';
import { CustomerDetail } from './pages/admin/CustomerDetail';
import { Settings } from './pages/admin/Settings';
import { company } from './data/site';
import { applyBrandIcon } from './utils/favicon';
function RequireAdmin({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    loggedIn,
    authLoading
  } = useAdminData();
  if (authLoading) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-canvas" data-id="element-0" data-mp="3ij61y35c994p">
        <p className="flex items-center gap-2 text-[15px] text-ink-muted" data-id="element-1" data-mp="3mkhnnxl3da7m">
          <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-2" data-mp="3rbrayrj641gc" />
          Henter …
        </p>
      </div>;
  }
  if (!loggedIn) return <Navigate to="/admin/login" replace data-id="element-3" data-mp="56mnfkhz7n0" />;
  return <>{children}</>;
}
export function App() {
  useEffect(() => {
    applyBrandIcon(company.logoMark, 'Lykkeværk');
  }, []);
  return <AdminDataProvider data-id="element-4" data-mp="33nghwajpr62m">
      <BrowserRouter data-id="element-5" data-mp="33orjq4tlm3r3">
        <Routes data-id="element-6" data-mp="38lrrqla0dgku">
          <Route path="/" element={<PublicSite data-id="element-8" data-mp="38l053zye2t6p" />} data-id="element-7" data-mp="38l8hlqqlnwhd" />
          <Route path="/admin/login" element={<AdminLogin data-id="element-10" data-mp="3dkl6eh117dml" />} data-id="element-9" data-mp="38nup5qdhqbzl" />
          <Route path="/admin" element={<RequireAdmin data-id="element-12" data-mp="nvstx4mognvy">
                <AdminShell data-id="element-13" data-mp="nuhicimzqbua" />
              </RequireAdmin>} data-id="element-11" data-mp="3dlw4q1bpjt6b">
            <Route index element={<Overview data-id="element-15" data-mp="stc9c7v436ph" />} data-id="element-14" data-mp="su427axbqqc2" />
            <Route path="henvendelser" element={<Enquiries data-id="element-17" data-mp="36861i5q6iv0" />} data-id="element-16" data-mp="swqchiblnjxz" />
            <Route path="sager" element={<Cases data-id="element-19" data-mp="34nc9ur8j3y7" />} data-id="element-18" data-mp="35gnb7x88fm5" />
            <Route path="sager/ny" element={<CaseNew data-id="element-21" data-mp="3udkoe0ich2ci" />} data-id="element-20" data-mp="3uct43lu76r1j" />
            <Route path="sager/:caseId" element={<CaseDetail data-id="element-23" data-mp="3uf5m1yzyh1el" />} data-id="element-22" data-mp="3uc9l01st9wlx" />
            <Route path="kunder" element={<Customers data-id="element-25" data-mp="d3crffrqyaar" />} data-id="element-24" data-mp="d57d4waue6fw" />
            <Route path="kunder/:customerId" element={<CustomerDetail data-id="element-27" data-mp="85bbh3pmar3i" />} data-id="element-26" data-mp="d2l6cyvrzuyq" />
            <Route path="indstillinger" element={<Settings data-id="element-29" data-mp="3gle88ef6yvd2" />} data-id="element-28" data-mp="86499f6lm69i" />
          </Route>
          <Route path="*" element={<Navigate to="/" replace data-id="element-31" data-mp="3glnxu0wbr0i8" />} data-id="element-30" data-mp="3gmfsn9i3ku7g" />
        </Routes>
      </BrowserRouter>
    </AdminDataProvider>;
}